import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from '../slice/userSlice';
import festReducer from '../slice/festSlice';
import groupReducer from '../slice/groupSlice';
import eventReducer from '../slice/eventSlice';
import participantReducer from '../slice/participantSlice';
import judgeReducer from '../slice/judgeSlice';
import teamLeadReducer from '../slice/teamLeadSlice';
import coordinatorReducer from '../slice/coordinatorSlice';
import volunteerReducer from '../slice/volunteerSlice';
import customRoleReducer from '../slice/customRoleSlice';

const userPersistConfig = {
  key: 'User',
  storage,
};

const teamLeadPersistConfig = {
  key: 'TeamLead',
  storage,
};

const judgePersistConfig = {
  key: 'Judge',
  storage,
  whitelist: ['selectedFest', 'fests'],
};

const coordinatorPersistConfig = {
  key: 'Coordinator',
  storage,
  whitelist: ['selectedFest'],
};

const customRolePersistConfig = {
  key: 'CustomRole',
  storage,
  whitelist: ['selectedFest'],
};

const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedTeamLeadReducer = persistReducer(teamLeadPersistConfig, teamLeadReducer);
const persistedJudgeReducer = persistReducer(judgePersistConfig, judgeReducer);
const persistedCoordinatorReducer = persistReducer(coordinatorPersistConfig, coordinatorReducer);
const persistedCustomRoleReducer = persistReducer(customRolePersistConfig, customRoleReducer);

const Store = configureStore({
  reducer: {
    User: persistedUserReducer,
    Fest: festReducer,
    Group: groupReducer,
    Event: eventReducer,
    Participant: participantReducer,
    Judge: persistedJudgeReducer,
    TeamLead: persistedTeamLeadReducer,
    Coordinator: persistedCoordinatorReducer,
    Volunteer: volunteerReducer,
    CustomRole: persistedCustomRoleReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(Store);
export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
export default Store;
